/* global newrelic */
import { setState, getState } from '../state';

const shouldSuppressError = ({ message }) => {
  if (/-\scancelled$/.test(message)) {
    return true;
  }

  return false;
};

const maskedFields = new Set([
  'firstName',
  'lastName',
  'addressLine1',
  'addressLine2',
  'city',
  'stateProvince',
  'zipCode',
  'number',
  'country',
  'cardHolderName',
  'expirationMonth',
  'expirationYear',
  'accountNumberXref',
  'creditTenderTypeId',
  'cardClass',
  'creditHostId',
  'issuedCountryCode',
  'paymentToken',
  'bin',
  'isGSA',
  'isPrepaid',
  'encryptionBlock',
  'cardSecurityIndicator',
  'encryptionType',
  'cardCaptureSessionID',
  'encryptionBlockFields',
  'keyId',
  'xrefCardNumber',
  'buyerId',
]);

/**
 * Masks sensitive data fields in the provided object. If the object contains nested objects,
 * the function recursively processes them to mask sensitive fields at all levels.
 *
 * @param {Object} variables - The input object containing data to be masked. It may include nested objects.
 * @returns {Object} A new object with sensitive fields masked. The structure of the original object is preserved.
 *                   Sensitive fields are replaced with '****', and non-sensitive fields remain unchanged.
 * @example
 * const input = { firstName: 'John', address: { city: 'New York', zipCode: '10001' } };
 * const output = maskData(input);
 * // output: { firstName: '****', address: { city: 'New York', zipCode: '****' } }
 */

export const maskData = (variables) => {
  const maskedVariables = { ...variables };
  Object.keys(variables).forEach((key) => {
    if (maskedFields.has(key)) {
      // Mask the value of the sensitive field
      maskedVariables[key] = '****';
    } else if (typeof variables[key] === 'object' && variables[key]) {
      maskedVariables[key] = maskData(variables[key]);
    }
  });
  return maskedVariables;
};

export const dataSources = () => {
  // this is happening way too much and need to put in some fix
  // window.LIFE_CYCLE_EVENT_BUS.on('data-sources.data', ({ output }) => {
  //   const { variables: { itemId }, data, queryName } = output;
  //   if (itemId) {
  //     const products = {
  //       [itemId]: data,
  //       currentItemId: itemId
  //     };
  //     setState({ products });
  //   }
  //
  //   if (queryName) {
  //     newrelic.addPageAction('operationsClient', {
  //       queryName
  //     });
  //   }
  //
  // });

  window.LIFE_CYCLE_EVENT_BUS.on('data-sources.trace', ({ output }) => {
    const { parentTraceId, traceId, mcvsId } = output;
    if (
      typeof traceId !== 'undefined'
      && typeof parentTraceId !== 'undefined'
      && typeof mcvsId !== 'undefined'
    ) {
      newrelic.addPageAction('operationsClient', {
        parentTraceId,
        traceId,
        mcvsId,
      });
    }
  });

  window.LIFE_CYCLE_EVENT_BUS.on('data-sources.error', ({ output }) => {
    const {
      message, variables, parentTraceId = '', traceId = '', mcvsId = ''
    } = output;
    if (typeof newrelic !== 'undefined' && message) {
      // newrelic.noticeError(message);
      const cookieSize = document.cookie.length;
      const queryString = document.location.search;
      const shouldLog = !shouldSuppressError({ message, variables });
      let maskedVariables = variables;
      if (maskedVariables) {
        maskedVariables = maskData(variables);
      }

      if (shouldLog) {
        newrelic.addPageAction('GQLError', {
          message,
          cookieSize,
          queryString,
          gqlVariables: JSON.stringify(maskedVariables || {}),
          parentTraceId,
          traceId,
          mcvsId,
        });
      }
    }
  });
};
